export default class ROICalc {
  constructor(constants, employees) {
    this.constants = constants
    this.employees = employees
    this.setConstants()
  }

  setConstants() {
    this.ticketsPerEmployee = this.constants.ticketsPerEmployee
    this.costSavingsPerTicket = this.constants.costSavingsPerTicket
    this.minsSavedPerEmployee = this.constants.minsSavedPerEmployee
    this.hourlyRateProductivity = this.constants.hourlyRateProductivity
    this.approvalsPerEmployee = this.constants.approvalsPerEmployee
    this.timeSavedPerApproval = this.constants.timeSavedPerApproval
    this.hourlyRateApprovals = this.constants.hourlyRateApprovals
  }

  calculateItSavings() {
    const ticketsPerYear = this.ticketsPerEmployee * this.employees * 12
    const annualItSavings = ticketsPerYear * this.costSavingsPerTicket

    return {
      raw: this.validateResult(annualItSavings), 
      formatted: this.formatResult(annualItSavings),
      ticketsPerEmp: this.ticketsPerEmployee,
    }
  }

  calculateProductivitySavings() {
    const minsSavedPerWeek = this.employees * this.minsSavedPerEmployee
    const hoursSavedPerWeek = minsSavedPerWeek / 60
    const savingsPerWeek = hoursSavedPerWeek * this.hourlyRateProductivity
    const annualProductivitySavings = savingsPerWeek * 52

    return {
      hoursSaved: Math.round(hoursSavedPerWeek), 
      raw: this.validateResult(annualProductivitySavings), 
      formatted: this.formatResult(annualProductivitySavings),
    }
  }

  calculateApprovalsSavings() {
    const approvals = this.employees * this.approvalsPerEmployee
    const secondsSaved = approvals * this.timeSavedPerApproval
    const hoursSaved = secondsSaved / 3600
    const annualApprovalsSavings = hoursSaved * this.hourlyRateApprovals
    
    return { 
      raw: this.validateResult(annualApprovalsSavings), 
      formatted: this.formatResult(annualApprovalsSavings), 
    }
  }

  calculateTotalSavings() {
    const total = 
      this.calculateProductivitySavings().raw + 
      this.calculateItSavings().raw + 
      this.calculateApprovalsSavings().raw

    return {
      raw: total, 
      formatted: this.formatResult(total)
    }
  }

  validateResult(result) {
    let returnValue
    isNaN(result) ? 
      returnValue = 0 
      : returnValue = result
    return returnValue
  }

  formatResult(result) {
    const formattedResult = 
      this.validateResult(result)
      .toLocaleString("en-US", {
        style:"currency", 
        currency:"USD", 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0}
      )
    
    return formattedResult
  }
}